import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const Navigation = () => {
  return (
    <div className="navigation-container">
      <div className="navigation-header">
        <h1>理想汽车功能导航</h1>
        <p>选择要访问的功能模块</p>
      </div>
      
      <div className="navigation-grid">
        <Link to="/login" className="nav-card">
          <div className="nav-icon">🔐</div>
          <h3>用户登录</h3>
          <p>登录系统访问完整功能</p>
        </Link>
        
        <Link to="/3d" className="nav-card">
          <div className="nav-icon">🎮</div>
          <h3>三维模型展示</h3>
          <p>Three.js 3D场景演示</p>
        </Link>
        
        <Link to="/sign" className="nav-card">
          <div className="nav-icon">✍️</div>
          <h3>签名收集</h3>
          <p>数字签名功能</p>
        </Link>
        
        <Link to="/s" className="nav-card">
          <div className="nav-icon">👁️</div>
          <h3>查看页面</h3>
          <p>查看相关信息</p>
        </Link>
        
        <Link to="/home" className="nav-card">
          <div className="nav-icon">🏠</div>
          <h3>主页面</h3>
          <p>访问主要功能模块</p>
        </Link>
      </div>
      
      <div className="navigation-footer">
        <p>理想汽车2025春季合作伙伴讨论会</p>
      </div>
    </div>
  );
};

export default Navigation;